<template>
  <div class="container">
    <!-- v-loading="!qyTree.length" -->
    <template v-if="qyTree.length">
      <div v-show="selectCompShow">
        <div
          class="cont flex-ac"
          style="height: 40px"
          v-if="typeList.length > 1"
        >
          <el-radio-group v-model="typeOn" size="mini">
            <el-radio-button v-for="(it, i) in typeList" :key="i" :label="it" />
          </el-radio-group>
        </div>
      </div>
      <div v-show="selectCompShow" style="padding: 0 10px">
        <!-- <div
          class="cont flex-ac flex-sb"
          style="height: 40px"
          v-if="
            typeOn != 'Region' &&
            typeOn != 'Street' &&
            typeOn != '南沙区' &&
            typeOn != '镇街'
          "
        >
          <el-checkbox-group v-model="line_value" size="mini">
            <el-checkbox
              v-for="it in line_options"
              :label="it.value"
              :key="it.value"
            >
              {{ it.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div> -->
        <div v-show="selectCompShow">
          <div class="cont flex-ac" style="height: 40px">
            <el-input
              size="mini"
              placeholder="公司名称/排污许可"
              v-model="filterTree"
              clearable
            />
          </div>
        </div>
      </div>
      <div
        v-show="selectCompShow"
        class="cont scroll"
        :style="{
          height:
            'calc(100% - ' +
            (typeList.length > 1 ? '40px' : '0') +
            (typeOn != 'Region' &&
            typeOn != 'Street' &&
            typeOn != '南沙区' &&
            typeOn != '镇街'
              ? ' - 0'
              : '') +
            ')',
        }"
      >
        <el-tree
          :data="qyTree"
          node-key="value"
          ref="tree"
          highlight-current
          @node-click="treeLabelClick"
          :default-expand-all="true"
          :filter-node-method="filterNode"
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node flex-ac" slot-scope="{ node, data }">
            <img
              :src="treeIcon(node).img"
              alt=""
              class="treeIcon"
              :class="treeIcon(node).class"
              v-if="treeIcon(node)"
            />
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
      <!-- <div
        v-show="selectCompShow"
        class="cont flex-ac flex-sa tj"
        style="height: 40px"
      >
        <span
          >企业：{{
            !filterTree && !qylx_value.length && !line_value.length
              ? enterpriseCount
              : Enterprise_arr.length
          }}个</span
        >
        <span
          >站点：{{
            !filterTree && !qylx_value.length && !line_value.length
              ? stationCount
              : Station_arr.length
          }}个</span
        >
      </div> -->
      <div class="selectCompShow">
        <div
          class="flex-col"
          @click="selectCompShowClick"
          v-show="!selectCompShow"
        >
          <span>展</span>
          <span>开</span>
          <span class="el-icon-d-arrow-right" />
        </div>

        <div
          class="flex-col"
          @click="selectCompShowClick"
          v-show="selectCompShow"
        >
          <span>收</span>
          <span>起</span>
          <span class="el-icon-d-arrow-left" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  GetChildAreaSelect,
  GetEnterpriseTypeSelect,
  GetParentLevelStationTree,
} from "@/api/baseData";
import { GetEnterpriseSelect } from "@/api/enterpriseConfig";
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters([""]),
  },
  props: ["typeArr", "default_type", "parentsClickFlag", "tabsOn"],
  data() {
    return {
      selectCompShow: true,
      enterpriseCount: 0,
      stationCount: 0,
      Enterprise_arr: [],
      Station_arr: [],
      Enterprise_count: 0,
      Station_count: 0,
      typeKey: {
        区县: "Region",
        镇街: "Street",
        企业: "Enterprise",
        站点: "Station",
        Region: "区县",
        Street: "镇街",
        Enterprise: "企业",
        Station: "站点",
      },
      typeList: ["区县", "镇街", "企业", "站点"],
      typeOn: "区县",
      qyTree: [],
      filterTree: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      qylx_options: [],
      qylx_value: [],
      line_options: [
        {
          label: "在线",
          value: "online",
        },
        {
          label: "离线",
          value: "offline",
        },
      ],
      line_value: [],
      first: true,
    };
  },
  watch: {
    // tabsOn() {
    //   this.GetParentLevelStationTree();
    // },
    typeOn(v) {
      this.$parent.default_type = v;
      this.GetParentLevelStationTree();
    },
    filterTree(val) {
      this.Enterprise_arr = [];
      this.Station_arr = [];

      this.$refs.tree.filter("");
    },
    qylx_value(v) {
      this.Enterprise_arr = [];
      this.Station_arr = [];

      this.$refs.tree.filter("");
    },
    line_value(v) {
      this.Enterprise_arr = [];
      this.Station_arr = [];

      this.$refs.tree.filter("");
    },
  },
  mounted() {
    this.typeList = this.typeArr;
    this.typeOn = this.typeKey[this.default_type];
    this.GetEnterpriseTypeSelect();
    this.GetParentLevelStationTree();
  },
  methods: {
    selectCompShowClick() {
      this.selectCompShow = !this.selectCompShow;
      this.$parent.selectCompShow = this.selectCompShow;
    },
    treeIcon(node) {
      if (
        (node.data.attributes.Tags.indexOf("Enterprise") > -1 ||
          node.data.attributes.Tags.indexOf("Station") > -1) &&
        node.data.icon
      ) {
        return {
          img: require("@/assets/images/icon/" + node.data.icon + ".png"),
          class:
            node.data.attributes.Tags.indexOf("Enterprise") > -1
              ? "treeIcon_e"
              : "treeIcon_s",
        };
      }
      return;
    },
    treeLabelClick(it) {
      if (
        it.attributes.Tags.indexOf(this.typeKey[this.typeOn]) > -1 ||
        this.parentsClickFlag
      ) {
        this.$emit("treelClick", {
          ...it,
          ...{
            parent: this.$refs.tree.getNode(it.key).parent.data[0]
              ? null
              : this.$refs.tree.getNode(it.key).parent.data,
          },
        });
      }
    },
    filterNode(value, data, parent) {
      if (
        !this.filterTree &&
        !this.qylx_value.length &&
        !this.line_value.length
      ) {
        return true;
      }
      const _this = this;
      // 判断交集
      function intersection(arr1, arr2) {
        let result = [];
        for (let i = 0; i < arr1.length; i++) {
          if (arr2.includes(arr1[i])) {
            result.push(arr1[i]);
          }
        }
        return result.length;
      }
      // 判断企业或者站点的数量统计是否+1
      function check_e_or_s(e, s) {
        if (e && e.value) {
          _this.Enterprise_arr.push(e.value);
          _this.Enterprise_arr = [...new Set(_this.Enterprise_arr)];
        }
        if (s && s.value) {
          _this.Station_arr.push(s.value);
          _this.Station_arr = [...new Set(_this.Station_arr)];
        }
      }
      let types = [];
      for (let i in this.qylx_value) {
        types.push(
          this.qylx_options.find((v) => v.label == this.qylx_value[i]).value
        );
      }
      function duplicate(arr, val) {
        let flag = false;
        for (let i in arr) {
          if (arr[i].indexOf(val) > -1) {
            flag = true;
            break;
          }
        }
        return flag;
      }
      let arr = [data.label];
      if (
        data.attributes.Tags.indexOf("Station") > -1 &&
        parent.parent.data.attributes
      ) {
        arr.push(parent.parent.data.attributes.OrganizationCode || "");
        arr.push(
          parent.parent.data.attributes.PollutantDischargePermitNumber || ""
        );
        arr.push(parent.parent.data.title || "");
        arr.push(parent.parent.data.attributes.OnlineStatus || "");
        arr.push(parent.parent.data.attributes.UniqueCode || "");
      } else {
        arr.push(data.attributes.OnlineStatus || "");
        arr.push(data.attributes.UniqueCode || "");
        arr.push(data.attributes.OrganizationCode || "");
        arr.push(data.attributes.PollutantDischargePermitNumber || "");
      }
      if (
        parent.parent.data &&
        Object.prototype.toString.call(parent.parent.data) === "[object Object]"
      ) {
        arr.push(parent.parent.data.label);
        arr.push(parent.parent.data.attributes.OnlineStatus || "");
        arr.push(parent.parent.data.attributes.UniqueCode || "");
        arr.push(parent.parent.data.attributes.OrganizationCode || "");
        arr.push(
          parent.parent.data.attributes.PollutantDischargePermitNumber || ""
        );
      }
      if (
        Object.prototype.toString.call(parent.parent.data) ===
          "[object Object]" &&
        Object.prototype.toString.call(parent.parent.parent.data) ===
          "[object Object]"
      ) {
        arr.push(parent.parent.parent.data.label);
        arr.push(parent.parent.parent.data.attributes.OnlineStatus || "");
        arr.push(parent.parent.parent.data.attributes.UniqueCode || "");
        arr.push(parent.parent.parent.data.attributes.OrganizationCode || "");
        arr.push(
          parent.parent.parent.data.attributes.PollutantDischargePermitNumber ||
            ""
        );
      }
      if (
        Object.prototype.toString.call(parent.parent.data) ===
          "[object Object]" &&
        Object.prototype.toString.call(parent.parent.parent.data) ===
          "[object Object]" &&
        Object.prototype.toString.call(parent.parent.parent.parent.data) ===
          "[object Object]"
      ) {
        arr.push(parent.parent.parent.parent.data.label);
        arr.push(parent.parent.parent.parent.data.attributes.UniqueCode || "");
        arr.push(
          parent.parent.parent.parent.data.attributes.OnlineStatus || ""
        );
        arr.push(
          parent.parent.parent.parent.data.attributes.OrganizationCode || ""
        );
        arr.push(
          parent.parent.parent.parent.data.attributes
            .PollutantDischargePermitNumber || ""
        );
      }
      if (
        Object.prototype.toString.call(parent.parent.data) ===
          "[object Object]" &&
        Object.prototype.toString.call(parent.parent.parent.data) ===
          "[object Object]" &&
        Object.prototype.toString.call(parent.parent.parent.parent.data) ===
          "[object Object]" &&
        Object.prototype.toString.call(
          parent.parent.parent.parent.parent.data
        ) === "[object Object]"
      ) {
        arr.push(
          parent.parent.parent.parent.parent.data.attributes.UniqueCode || ""
        );
        arr.push(
          parent.parent.parent.parent.parent.data.attributes.OrganizationCode ||
            ""
        );
        arr.push(parent.parent.parent.parent.parent.data.label);
        arr.push(
          parent.parent.parent.parent.parent.data.attributes.OnlineStatus || ""
        );
        arr.push(
          parent.parent.parent.parent.parent.data.attributes
            .PollutantDischargePermitNumber || ""
        );
      }
      // 如果勾选了在线/离线

      // 没有勾选在线离线
      // 如果勾选了类型
      // 如果是站点，且有企业
      let line_types = [];
      this.line_value.map((v) => {
        line_types.push(v);
        if (v == "offline") {
          line_types.push("none");
        }
        if (v == "online") {
          line_types.push("half");
        }
      });
      if (this.qylx_value.length && duplicate(arr, this.filterTree)) {
        if (data.attributes.Tags.indexOf("Station") == -1) {
          if (intersection(data.attributes.Tags, types)) {
            if (data.attributes.Tags.indexOf("Enterprise") > -1) {
              if (
                this.line_value.length
                  ? duplicate(arr, this.filterTree) &&
                    line_types.indexOf(data.attributes.OnlineStatus) > -1
                  : duplicate(arr, this.filterTree)
              ) {
                check_e_or_s(data, null);
                return this.line_value.length
                  ? true &&
                      line_types.indexOf(data.attributes.OnlineStatus) > -1
                  : true;
              }
              return false;
            }
          }
          return false;
        } else {
          if (
            Object.prototype.toString.call(parent.parent.data) ===
            "[object Object]"
          ) {
            if (intersection(parent.parent.data.attributes.Tags, types)) {
              if (
                this.line_value.length
                  ? duplicate(arr, this.filterTree) &&
                    line_types.indexOf(data.attributes.OnlineStatus) > -1
                  : duplicate(arr, this.filterTree)
              ) {
                check_e_or_s(null, data);
                return this.line_value.length
                  ? true &&
                      line_types.indexOf(data.attributes.OnlineStatus) > -1
                  : true;
              }
              return false;
            }
          } else {
            if (
              this.line_value.length
                ? intersection([], types) &&
                  line_types.indexOf(data.attributes.OnlineStatus) > -1
                : intersection([], types)
            ) {
              check_e_or_s(data, null);
              return this.line_value.length
                ? true && line_types.indexOf(data.attributes.OnlineStatus) > -1
                : true;
            }
            return false;
          }
        }
        if (intersection(data.attributes.Tags, types)) {
          if (
            this.line_value.length
              ? duplicate(arr, this.filterTree) &&
                line_types.indexOf(data.attributes.OnlineStatus) > -1
              : duplicate(arr, this.filterTree)
          ) {
            check_e_or_s(data);
            return this.line_value.length
              ? true && line_types.indexOf(data.attributes.OnlineStatus) > -1
              : true;
          }
          return false;
        }
      } else {
        // 卡在这里了，如果是企业的话，
        if (data.attributes.Tags.indexOf("Enterprise") > -1) {
          if (
            this.line_value.length
              ? duplicate(arr, this.filterTree) &&
                line_types.indexOf(data.attributes.OnlineStatus) > -1
              : duplicate(arr, this.filterTree)
          ) {
            check_e_or_s(data, null);
            return this.line_value.length
              ? true && line_types.indexOf(data.attributes.OnlineStatus) > -1
              : true;
          }
          return false;
        }
      }
      if (!this.qylx_value.length && duplicate(arr, this.filterTree)) {
        if (
          this.line_value.length
            ? duplicate(arr, this.filterTree) &&
              line_types.indexOf(data.attributes.OnlineStatus) > -1
            : duplicate(arr, this.filterTree)
        ) {
          check_e_or_s(parent.parent.data, data);
          return this.line_value.length
            ? true && line_types.indexOf(data.attributes.OnlineStatus) > -1
            : true;
        }
        return false;
      }
    },

    GetEnterpriseTypeSelect() {
      GetEnterpriseTypeSelect({
        parentId: window.codeId,
      }).then((res) => {
        if (res.code == 401) {
          this.$config.getNewToken(this, () => {
            this.GetEnterpriseTypeSelect();
          });
        } else {
          this.qylx_options = res.result;
        }
      });
    },
    GetParentLevelStationTree() {
      let enterpriseTypeIds = [];
      for (let i in this.qylx_options) {
        if (this.qylx_value.indexOf(this.qylx_options[i].label) > -1)
          enterpriseTypeIds.push(this.qylx_options[i].value);
      }
      GetParentLevelStationTree({
        levelTagId: this.typeKey[this.typeOn],
        includeStationTagTypes: null,
      }).then((res) => {
        if (res.code == 401) {
          this.$config.getNewToken(this, () => {
            this.GetParentLevelStationTree();
          });
        } else {
          this.qyTree = res.result.tree;
          this.enterpriseCount = res.result.enterpriseCount;
          this.stationCount = res.result.stationCount;
          this.$nextTick(() => {
            this.$refs.tree.filter("");
          });
        }
      });
    },
  },
  destroyed() {},
};
</script>
<style lang="stylus" scoped>
.container {
  position: relative;
}

.el-checkbox {
  margin-right: 10px;
}

>>>.el-input--mini .el-input__inner {
  width: 100%;
}

.el-tree {
  width: max-content;
  min-width: 100%;
  padding-right: 10px;
}

.treeIcon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.treeIcon_s {
  width: 16px;
  height: 16px;
}

.tj {
  color: #666;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.selectCompShow {
  position: absolute;
  top: 50%;
  right: 0;
  cursor: pointer;
  background: rgb(229, 229, 229);
  padding: 10px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/selectComp.vue